"use client";

import React from "react";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import styled from "styled-components";
import LoaderBlock from "@/components/shared/LoaderBlock";

export default async function Loading() {

  return <Wrapper>
    <Content>
      <LoaderBlock height="45px" />
      <LoaderBlock height="450px" />
      <LoaderBlock height="250px" />
    </Content>
    <Content>
      <LoaderBlock height="650px" />
      <LoaderBlock height="200px" />
    </Content>
  </Wrapper>
}
const Content = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  grid-gap: ${({ theme }) => theme.space.S};
`;

const Wrapper = styled(Box)`
  display: flex;
  justify-content: space-between;

  > div:nth-child(1) {
    width: calc(65% - ${({ theme }) => theme.space.S});
  }

  > div:nth-child(2) {
    width: calc(35% - ${({ theme }) => theme.space.S});
  }

  @media (max-width: 1200px) {
    > div:nth-child(1) {
      width: calc(60% - ${({ theme }) => theme.space.S});
    }

    > div:nth-child(2) {
      width: calc(40% - ${({ theme }) => theme.space.S});
    }
  }

  @media (max-width: 1000px) {
    flex-direction: column;

    > div {
      width: 100% !important;
    }
  };
  `;
